import React from 'react';
import { getDepartmentData, getDesiginationData } from '../../service/adminApi';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import { useNavigate } from 'react-router-dom';
import { getTimestampToDate } from '../../utils/dateConvetor';

function Domains() {
    const navigate = useNavigate();
    const [domainList, setDomainList] = React.useState([]);
    const [breadCrumbs] = React.useState([
        { title: 'Dashboard', path: '/Overview', isActive: true },
        { title: 'Admin', path: '/admin/accountbranding', isActive: true },
        { title: 'Recruitment Settings', path: '/admin/recuritementmessage', isActive: true },
        { title: 'Questionnaires - Experienced', path: '', isActive: false },
    ]);

    React.useEffect(() => {
        getDepartments();
    }, []);

    const getDepartments = async () => {
        const response = await getDepartmentData();
        setDomainList(response.data.data);
    };

    const handleDesignationNavigate = (domainId) => {
        navigate(`${domainId}`);
    };

    const renderDomainList = () => {
        return (
            <div className="row">
                <ul className="list-unstyled my-2">
                    {domainList.map((domain, index) => {
                        let date = domain.lastmodified !== '' ? getTimestampToDate(domain.lastmodified, 3) : '';
                        return (
                            <li
                                onClick={() => {
                                    handleDesignationNavigate(domain.id);
                                }}
                                className="my-2 bg-white goal-li-sty py-3 px-3"
                            >
                                <div className="d-flex justify-content-between border-none bg-white">
                                    <div className="col-md-3 d-flex align-self-center">
                                        <div className="d-block align-self-center">
                                            <a href="#" className="text-deco-none">
                                                <img src="/Images/orange-arrow.svg" alt="orange-arrow" className="me-2" />
                                            </a>
                                        </div>
                                        <div className="ps-3">
                                            <h6 className="tt-bold font-15 policy-darkbluefont pt-2">{domain.department_name}</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-2 text-center align-self-center">
                                        <span className="status-btn bg-pastel-blue font-14">{domain.desiginationCount} Roles</span>
                                    </div>
                                    <div className="col-md-3 text-center align-self-center">
                                        <span className="status-btn font-grey font-14">
                                            {date !== '' || date !== undefined ? `Last Updated - ${date}` : ''}
                                        </span>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbs} />
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between">
                        <h5 className="bold-text tt-bold font-18">Questions - Experienced</h5>
                    </div>
                </div>
            </div>

            {renderDomainList()}
        </div>
    );
}

export default Domains;
